function isEleVisible(ele){
    var {top, right, bottom, left} = ele.getBoundingClientRect()
    var w = window.innerWidth
    var h = window.innerHeight
    if(bottom < 0 || top > h - 300){
        return false
    }
    return true
}

// 适配头部导航栏的sticky布局
const q7maxContainer = document.getElementById('q7max-container')
let { top: topHeight } = q7maxContainer.getBoundingClientRect()
topHeight = Math.max(topHeight, 0)
document.getElementById('section-first').style.top = topHeight + 'px'
document.getElementById('section-first').style.height = 'calc(100vh - ' + topHeight + 'px)'

window.addEventListener("scroll", function (){
    var section1 = document.getElementById('section-first'),
        section2 = document.getElementById('section-second'),
        section3 = document.getElementById('section-third');
    if(isEleVisible(section1)) {
        var { top } = q7maxContainer.getBoundingClientRect()
        const ele = document.getElementById('section-first-text-area')
        if (top < topHeight - 60) {
            ele.classList.add('opacity-0')
            section1.classList.add('my-modal')
        } else {
            ele.classList.remove('opacity-0')
            section1.classList.remove('my-modal')
        }
    }
    if(isEleVisible(section2)) {
        const textArea = document.querySelector('.section-second .text-area')
        var { bottom } = textArea.getBoundingClientRect()
        if(bottom <= window.innerHeight * 0.9) {
            textArea.classList.add('moveTopAnimation2')
        } else {
            textArea.classList.remove('moveTopAnimation2')
        }
    }
    if(isEleVisible(section3)){
        let labelArea = document.querySelector('.section-third .content-list')
        let { bottom: labelAreaBottom } = labelArea.getBoundingClientRect()
        const items = labelArea.querySelectorAll('.list-item')
        if(window.innerWidth <= 750) {
            if(labelAreaBottom <= window.innerHeight){
                for(let i = 0; i < items.length; i++) {
                    i < 2 && items[i].classList.add('moveTopAnimation3')
                    i >= 2 && i < 4 && items[i].classList.add('moveTopAnimation4')
                    i >= 4 && items[i].classList.add('moveTopAnimation5')
                }
            } else {
                for(let i = 0; i < items.length; i++) {
                    i < 2 && items[i].classList.remove('moveTopAnimation3')
                    i >= 2 && i < 4 && items[i].classList.remove('moveTopAnimation4')
                    i >= 4 && items[i].classList.remove('moveTopAnimation5')
                }
            }
        } else{
            if(labelAreaBottom <= window.innerHeight) {
                for(let i = 0; i < items.length; i++) {
                    i % 2 === 0 && items[i].classList.add('moveTopAnimation3')
                    i % 2 === 1 && items[i].classList.add('moveTopAnimation5')
                }
            } else {
                for(let i = 0; i < items.length; i++) {
                    i % 2 === 0 && items[i].classList.remove('moveTopAnimation3')
                    i % 2 === 1 && items[i].classList.remove('moveTopAnimation5')
                }
            }
        }
    }
})






// 让动画晚点出现
window.addEventListener("DOMContentLoaded", function () {  //添加DOMContentLoaded事件
    document.querySelector('.animation-move-top').style.animation = 'moveTop 0.8s ease forwards'
}, false)